export enum InternalTypeEnum {
  TASK = "Task",
  SPIKE = "Spike",
  EVENT = "Event",
}
